module.exports = __webpack_public_path__ + "static/img/WB1000-PF_A.f39b4f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WB1000-PF_A.jpg
// module id = oHQ+
// module chunks = 0